<template>
	<menu class="flex flex-wrap items-center gap-4 px-24">
		<BaseTag :toggled="!areAllGroupsToggled" class="dark" @click="$emit('toggle', 'all')"> All </BaseTag>
		<div class="border-l border-gray-650 h-20" />
		<BaseTag
			v-for="toggleGroup in displayedToggleGroups"
			:key="toggleGroup"
			:data-test="`console-${toggleGroup.replaceAll(' ', '-').toLowerCase()}-button`"
			:toggled="isToggled(toggleGroup)"
			class="dark"
			@click="$emit('toggle', toggleGroup)"
		>
			<BaseIcon
				:name="toggleGroups[toggleGroup].icon"
				:class="{
					[toggleGroups[toggleGroup].class]: !hiddenConsoleToggleGroups.includes(toggleGroup),
				}"
				class="w-12 h-12 mr-8"
			/>
			{{ toggleGroup }}
		</BaseTag>
	</menu>
</template>

<script>
export default {
	name: 'SessionConsoleToolbar',
	props: {
		displayedToggleGroups: {type: Array, default: () => []},
		toggleGroups: {type: Object, default: () => ({})},
		hiddenConsoleToggleGroups: {type: Array, default: () => []},
	},
	emits: ['toggle'],
	computed: {
		areAllGroupsToggled() {
			return this.hiddenConsoleToggleGroups.filter(Boolean).length === 0
		},
	},
	methods: {
		isToggled(toggleGroup) {
			return this.hiddenConsoleToggleGroups.includes(toggleGroup)
		},
	},
}
</script>
